<template>
  <div class="rich-text-preview">
    <div class="preview"
         v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: 'RichTextPreview',
  props: {
    html: String
  },
  methods: {
    bindEvent () {
      this.$el.addEventListener('click', this.onPreview)
    },
    unbindEvent () {
      this.$el.removeEventListener('click', this.onPreview)
    },
    onPreview (event) {
      const target = event.target || event.srcElement
      if (target && target.tagName === 'IMG') {
        const targetSrc = target.getAttribute('src')
        if (targetSrc) {
          const images = this.$el.querySelectorAll('.preview img')
          const previewList = []
          let initialIndex = 0
          images.forEach(image => {
            const src = image.getAttribute('src')
            if (src) {
              if (image === target) {
                initialIndex = previewList.length
              }
              previewList.push(src)
            }
          })
          this.$previewImage(previewList, initialIndex)
        }
      }
    }
  },
  mounted () {
    this.bindEvent()
  },
  beforeDestroy () {
    this.unbindEvent()
  }
}
</script>

<style lang="scss">
  .rich-text-preview {
    font-size: 14px;
    line-height: 150%;
    word-break: break-all;
    word-wrap: break-word;
    p {
      margin: unset;
    }
    img {
      max-width: 100%;
      cursor: pointer;
    }
  }
</style>
